import { render, staticRenderFns } from "./ECommerceAddProductMedia.vue?vue&type=template&id=2867956d&scoped=true&"
import script from "./ECommerceAddProductMedia.vue?vue&type=script&lang=js&"
export * from "./ECommerceAddProductMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867956d",
  null
  
)

export default component.exports